import styled from "styled-components";

export const ButtonWrapper = styled.div`
  width: 280px;
  margin: auto;
`;